import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { Star } from 'lucide-react';
const testimonials = [{
  image: 'https://cdn.magicpatterns.com/uploads/sEZLsPoKqudQRSuPNqYXSi/Testimonio_2.png',
  quote: 'Llevaba años buscando algo que realmente entendiera lo que vivimos las mujeres después de los 50. Este plan no me prometió milagros, me dio herramientas reales que sí funcionan. A los 10 días ya tenía claridad mental y energía estable. Hoy me siento como yo otra vez.',
  name: 'María Elena',
  age: '54 años'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/3gQ63VZ5y4iVPVwjTvhqUs/Testimonio_1.png',
  quote: 'Lo que más me gustó es que está escrito para mujeres reales, con vidas reales. No tuve que cambiar mi rutina entera, solo aplicar pequeños ajustes que marcaron una gran diferencia. Mi sueño mejoró desde la primera semana. Lo recomiendo de corazón.',
  name: 'Carmen Rodríguez',
  age: '56 años'
}];
export const TestimonialsSection = () => {
  return <Section bg="bg-cream-light" data-id="element-296">
      <FadeIn data-id="element-297">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-298">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-brown mb-6 leading-tight" data-id="element-299">
            Historias{' '}
            <span className="text-gold italic font-normal" data-id="element-300">reales</span>
          </h2>
        </div>
      </FadeIn>

      <StaggerContainer className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-301">
        {testimonials.map((testimonial, idx) => <StaggerItem key={idx} data-id="element-302">
            <div className="bg-white border border-cream-dark rounded-3xl p-8 md:p-10 shadow-md h-full flex flex-col" data-id="element-303">
              <div className="flex items-center gap-5 mb-6" data-id="element-304">
                <div className="w-20 h-20 rounded-full overflow-hidden border-4 border-cream-light shrink-0 shadow-sm" data-id="element-305">
                  <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover" data-id="element-306" />
                </div>
                <div data-id="element-307">
                  <div className="flex gap-1 mb-1" data-id="element-308">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold text-gold" data-id="element-309" />)}
                  </div>
                  <p className="font-bold text-brown text-lg" data-id="element-310">
                    {testimonial.name}
                  </p>
                  <p className="text-brown-light text-sm" data-id="element-311">{testimonial.age}</p>
                </div>
              </div>
              <p className="text-brown-light leading-relaxed italic flex-1" data-id="element-312">
                "{testimonial.quote}"
              </p>
            </div>
          </StaggerItem>)}
      </StaggerContainer>
    </Section>;
};